import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {fetchCorporateUsers, fetchDealershipUsers} from '../actions/dealership.actions';
import ListState from '../states/list.state';

const initialState: ListState = {
  loading: false,
  data: [],
  error: null,
  meta: null,
};

const DealershipUserSlice = createSlice({
  name: 'dealershipsUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDealershipUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDealershipUsers.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchDealershipUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? null;
      });
  },
});

export default DealershipUserSlice.reducer;